// utils/paymentMethod.ts — Satu sumber kebenaran metode bayar: kanonik = 'COD' | 'Transfer Bank' | 'QRIS'.
// Semua variasi DB (cod/bankTransfer/Transfer/dll) dikunci ke kanonik di DB (trigger
// normalize_payment_method) + di sini untuk filter/display. Hapus duplikat metode bayar.
export const PAYMENT_METHOD_CANONICAL = {
  COD: 'COD',
  TransferBank: 'Transfer Bank',
  QRIS: 'QRIS',
} as const;

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  'COD': 'Bayar di Tempat (COD)',
  'Transfer Bank': 'Transfer Bank',
  'QRIS': 'QRIS',
};

// Variasi DB yang pernah/akan ada — untuk query filter (semua harus cocok dgn trigger DB).
export const PAYMENT_METHOD_VARIANTS: Record<string, string[]> = {
  'COD': ['COD', 'cod', 'Bayar di Tempat (COD)', 'COD Jawa-Bali', 'COD Luar Jawa-Bali', 'codJawaBali', 'codLuarJawaBali'],
  'Transfer Bank': ['Transfer Bank', 'Transfer', 'transfer', 'bankTransfer'],
  'QRIS': ['QRIS', 'qris'],
};

export type PaymentMethodCanonical = (typeof PAYMENT_METHOD_CANONICAL)[keyof typeof PAYMENT_METHOD_CANONICAL];

export function canonicalPaymentMethod(v?: string | null): string | null {
  const raw = String(v || '').trim();
  if (!raw) return null;
  const s = raw.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (s.includes('cod') || s.includes('bayarditempat')) return PAYMENT_METHOD_CANONICAL.COD;
  if (s.includes('transfer') || s.includes('bank')) return PAYMENT_METHOD_CANONICAL.TransferBank;
  if (s.includes('qris')) return PAYMENT_METHOD_CANONICAL.QRIS;
  return raw;
}

export const isCodMethod = (v?: string | null): boolean => canonicalPaymentMethod(v) === PAYMENT_METHOD_CANONICAL.COD;
export const isTransferMethod = (v?: string | null): boolean => canonicalPaymentMethod(v) === PAYMENT_METHOD_CANONICAL.TransferBank;
export const isQrisMethod = (v?: string | null): boolean => canonicalPaymentMethod(v) === PAYMENT_METHOD_CANONICAL.QRIS;

export function paymentMethodLabel(v?: string | null): string {
  const c = canonicalPaymentMethod(v);
  if (!c) return '(Kosong)';
  return PAYMENT_METHOD_LABELS[c] || c;
}
